import type { Message } from '../../contexts/ConversationContext';

export type CampArrivalState = 'pending' | 'resolved' | 'failed' | 'standby' | 'merged';

/**
 * Server-truth arrival state for a Camp (spine_root_marker) pin:
 *  - failed   = the peer's turn raised/timed out (metadata.turn_failed, set by
 *               council_peer_runner._mark_camp_failed) — outranks everything.
 *  - resolved = a peer turn already chained under the Camp (author_kind === 'peer').
 *  - pending  = a turn WAS dispatched (metadata.turn_dispatched) — peer "reading the trail…".
 *  - standby  = convened companion, no turn dispatched — "making camp" until consulted.
 * Recomputed from reloaded messages, so reconnect-mid-flight self-heals; legacy
 * sessions (no turn_dispatched key) compute `standby` via the truthy-check.
 */
export function campArrivalState(
  camp: Message,
  childrenByParent: Map<string, string[]>,
  byId: Map<string, Message>,
): CampArrivalState {
  if ((camp.metadata as any)?.turn_failed === true) return 'failed';
  const childIds = childrenByParent.get(camp.id) ?? [];
  const hasPeerChild = childIds.some((cid) => (byId.get(cid) as any)?.author_kind === 'peer');
  if (hasPeerChild) return 'resolved';
  // standby = convened (no dispatched turn); pending = a real peer turn is arriving.
  return (camp.metadata as any)?.turn_dispatched === true ? 'pending' : 'standby';
}
